"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGenericResult = exports.genericAsResultHeader = void 0;

var _modelBuilders = require("./model-builders");

/*
  Many DataServer responses have a header that looks like this:

    <{MethodName}Response xmlns="http://www.aperio.com/webservices/">
        <{MethodName}Result>
            <ASResult>0</ASResult>
            <ASMessage />
            <ASDetails />
        </{MethodName}Result>
        <body ... />
    </{MethodName}Response>

  This object provides a template for parsing the <{MethodName}Result> tag
 */
var genericAsResultHeader = {
  asResult: {
    type: Number,
    path: 'ASResult'
  },
  asMessage: {
    type: String,
    path: 'ASMessage'
  },
  asDetails: {
    type: String,
    path: 'ASDetails'
  }
};
exports.genericAsResultHeader = genericAsResultHeader;

var createGenericResult = function createGenericResult(raw, methodName) {
  return (0, _modelBuilders.parseModel)(raw, {
    result: {
      path: "".concat(methodName, "Result[0]"),
      model: genericAsResultHeader
    }
  });
};

exports.createGenericResult = createGenericResult;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/utils/generic-as-result-header.js
// module id = 16
// module chunks = 0